import api from '@/services/api';
import {
  keepPreviousData,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import type {
  ColumnFiltersState,
  PaginationState,
  SortingState
} from '@tanstack/react-table';
import { useEffect } from 'react';

export type GetPaymentsProps = {
  pagination: PaginationState;
  filtering: string;
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
};

const getQueryOptions = ({
  pagination,
  filtering,
  sorting,
  columnFilters
}: GetPaymentsProps) => {
  return {
    queryKey: [
      'payments',
      pagination,
      { search: filtering },
      sorting,
      columnFilters
    ],
    queryFn: () =>
      api.payments.getPaginatedPayments({
        pagination,
        filtering,
        sorting,
        columnFilters
      })
  };
};

const useGetPaginatedPayments = (props: GetPaymentsProps) => {
  const queryClient = useQueryClient();

  //prefetch next page
  useEffect(() => {
    queryClient.prefetchQuery(
      getQueryOptions({
        ...props,
        pagination: {
          ...props.pagination,
          pageIndex: props.pagination.pageIndex + 1
        }
      })
    );
  }, [queryClient, props]);

  return useQuery({
    ...getQueryOptions(props),
    placeholderData: keepPreviousData
  });
};

export default useGetPaginatedPayments;
